// extracted by mini-css-extract-plugin
module.exports = {"entitiesTable":"Fkahe","editEntityIcon":"bHspS"};